import {AmplifyAuthenticatorModule} from '@aws-amplify/ui-angular';
import {MatChipsModule} from '@angular/material/chips';
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatFormFieldModule} from "@angular/material/form-field";
import {FlexLayoutModule, FlexModule} from "@angular/flex-layout";
import {IsInRoleAndStatusForThisEntityDirective} from "./directives/is-in-role-and-status.directive";
import {RouterModule} from "@angular/router";
import {HomeComponent} from "./public/home/home.component";
import {RxReactiveFormsModule} from "@rxweb/reactive-form-validators";
import {MatPaginatorModule} from "@angular/material/paginator";
import {MatInputModule} from "@angular/material/input";
import {MatExpansionModule} from "@angular/material/expansion";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule} from "@angular/material/snack-bar";
import {MatMenuModule} from "@angular/material/menu";
import {MatSortModule} from "@angular/material/sort";
import {MatTableModule} from "@angular/material/table";
import {MatCardModule} from "@angular/material/card";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {PageNotFoundComponent} from "./public/page-not-found/page-not-found.component";
import {ProfileManagementComponent} from "./private/profile/profile-management/profile-management.component";
import {MatSelectModule} from "@angular/material/select";
import {MatIconModule} from "@angular/material/icon";
import {NgxMaskModule} from "ngx-mask";
import {MatSidenavModule} from "@angular/material/sidenav";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {DatePipe} from "@angular/common";
import {ContractDialogComponent} from "./private/contracts/contract-dialog/contract-dialog.component";
import {ConfirmDialogComponent} from "./shared-components/confirm-dialog/confirm-dialog.component";
import {AppComponent} from "./app.component";

import {
  TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT
} from "./to-be-implemented-placeholder/to-be-implemented-placeholder.component";
import {ListContractsComponent} from "./private/contracts/list-contracts/list-contracts.component";
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule} from "@angular/material/dialog";
import {CreateCompanyDialogComponent} from "./private/companies/create-company-dialog/create-company-dialog.component";
import {CompanyFormComponent} from "./private/companies/company-form/company-form.component";
import {DashboardComponent} from "./private/dashboard/dashboard.component";
import {ListTestbedsComponent} from "./private/testbeds/list-testbeds/list-testbeds.component";
import {MAT_DATE_LOCALE, MatNativeDateModule, MatOptionModule} from "@angular/material/core";
import {MatTreeModule} from "@angular/material/tree";
import {PublicContainerComponent} from "./public/public-container/public-container.component";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {ContractFormComponent} from "./private/contracts/contract-form/contract-form.component";
import {ListBoxesComponent} from "./private/boxes/list-boxes/list-boxes.component";
import {LoginComponent} from "./public/login/login.component";
import {ListSimsComponent} from "./private/sims/list-sims/list-sims.component";
import {APP_INITIALIZER, NgModule} from "@angular/core";
import {ListBoxInterfacesComponent} from "./private/box-interfaces/list-box-interfaces/list-box-interfaces.component";
import {AppRoutingModule} from "./app-routing.module";
import {GeneralInterceptorService} from "./services/general.interceptor.service";
import {MatButtonModule} from "@angular/material/button";
import {A11yModule} from "@angular/cdk/a11y";
import {IsAuthenticatedDirective} from "./directives/is-authenticated.directive";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {
  GeneralItemDetailDialogComponent
} from "./shared-components/general-item-detail-dialog/general-item-detail-dialog.component";
import {MatListModule} from "@angular/material/list";
import {AlertDialogComponent} from "./shared-components/alert-dialog/alert-dialog.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {SplitCamelCasePipe} from "./pipes/split-camel-case.pipe";
import {BrowserModule} from "@angular/platform-browser";
import {IsInAnyRoleDirective} from "./directives/is-in-any-role.directive";
import {MatBadgeModule} from "@angular/material/badge";
import {MatButtonToggleModule} from '@angular/material/button-toggle';

import {ListCompaniesComponent} from "./private/companies/list-companies/list-companies.component";
import {JwtInterceptorService} from "./services/jwt.interceptor.service";
import {PrivateContainerComponent} from "./private/private-container/private-container.component";

import {
  CreateBoxInterfaceDialogComponent
} from "./private/box-interfaces/create-box-interface-dialog/create-box-interface-dialog.component";
import {BoxInterfaceFormComponent} from "./private/box-interfaces/box-interface-form/box-interface-form.component";
import {CreateBoxDialogComponent} from "./private/boxes/create-box-dialog/create-box-dialog.component";
import {CreateSimDialogComponent} from "./private/sims/create-sim-dialog/create-sim-dialog.component";
import {CreateTestbedDialogComponent} from "./private/testbeds/create-testbed-dialog/create-testbed-dialog.component";
import {BoxFormComponent} from "./private/boxes/box-form/box-form.component";
import {SimFormComponent} from "./private/sims/sim-form/sim-form.component";
import {TestbedFormComponent} from "./private/testbeds/testbed-form/testbed-form.component";
import {
  ContractDialogStatusTransitionComponent
} from './private/contracts/contract-dialog-status-transition/contract-dialog-status-transition.component';
import {
  CreateContractDialogComponent
} from "./private/contracts/create-contract-dialog/create-contract-dialog.component";
import {
  ContractCardDashboardComponent
} from "./private/contracts/contract-card-dashboard-component/contract-card-dashboard.component";
import {ReplaceBooleanPipe} from "./pipes/replace-boolean.pipe";
import {IsInAnyStatusDirective} from "./directives/is-in-any-status.directive";
import {
  ListContractEventsComponent
} from "./private/contract-events/list-contract-events-component/list-contract-events.component";
import {ListBoxEventsComponent} from "./private/box-events/list-box-events/list-box-events.component";
import {AddResearchersToBoxComponent} from "./private/boxes/add-researchers-to-box/add-researchers-to-box.component";
import {AddBoxesToContractComponent} from "./private/contracts/add-boxes-to-contract/add-boxes-to-contract.component";
import {AddBoxesDialogComponent} from "./private/contracts/add-boxes-dialog/add-boxes-dialog.component";
import {AddResearchersDialogComponent} from "./private/boxes/add-researchers-dialog/add-researchers-dialog.component";
import {BoxDialogComponent} from "./private/boxes/box-dialog/box-dialog.component";
import {
  BoxDialogStatusTransitionComponent
} from "./private/boxes/box-dialog-status-transition/box-dialog-status-transition.component";
import {BoxCardDashboardComponent} from "./private/boxes/box-card-dashboard-component/box-card-dashboard.component";
import {
  CompanyCardDashboardComponent
} from "./private/companies/company-card-dashboard-component/company-card-dashboard.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {EnableBoxComponent} from "./private/boxes/enable-box-dialog/enable-box.component";
import {ListStorageComponent} from "./private/storage/list-storage/list-storage.component";
import {CreateStorageDialogComponent} from "./private/storage/create-storage-dialog/create-storage-dialog.component";
import {StorageFormComponent} from "./private/storage/storage-form/storage-form.component";

import {
  AddBoxInterfaceToBoxComponent
} from "./private/boxes/add-box-interface-to-box/add-box-interface-to-box.component";
import {
  AddBoxInterfaceDialogComponent
} from "./private/boxes/add-box-interface-dialog/add-box-interface-dialog.component";
import {TestbedCardDashboard} from "./private/testbeds/testbed-card-dashboard/testbed-card-dashboard";
import {AddSimToBoxComponent} from "./private/boxes/add-sim-to-box/add-sim-to-box.component";
import {AddSimDialogComponent} from "./private/boxes/add-sim-dialog/add-sim-dialog.component";
import {ListTestbedFilesComponent} from './private/storage/list-testbed-files/list-testbed-files.component';
import {FileSaverModule} from 'ngx-filesaver';
import {FileUploadDialogComponent} from './private/storage/file-upload-dialog/file-upload-dialog.component';
import {BytesPipe} from './pipes/bytes.pipe';
import {NotificationsComponent} from "./private/notifications/notifications.component";
import {StatusLegendDialogComponent} from "./shared-components/status-dialog/status-legend-dialog.component";
import {RecaptchaFormsModule, RecaptchaModule,} from 'ng-recaptcha';
import {
  BoxCardResearcherDashboardComponent
} from './private/boxes/box-card-researcher-dashboard-component/box-card-researcher-dashboard.component';
import {MatRadioModule} from "@angular/material/radio";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatTabsModule} from "@angular/material/tabs";
import {MatStepperModule} from '@angular/material/stepper';
import {
  ClientDownloadPageComponent
} from './private/client-download/client-download-page/client-download-page.component';
import {EmailVerificationComponent} from './public/email-verification/email-verification.component';
import {UserProfileComponent} from './private/profile/user-profile/user-profile.component';
import {FullCapsPipe} from './pipes/full-caps.pipe';
import {GravatarPictureComponent} from './private/profile/user-profile/gravatar-picture/gravatar-picture.component';
import {ClientEulaDialogComponent} from './private/client-download/client-eula-dialog/client-eula-dialog.component';
import {NgxGpAutocompleteModule} from "@angular-magic/ngx-gp-autocomplete";
import {Loader} from "@googlemaps/js-api-loader";
import {TestOutputPageComponent} from './private/test/test-output-page/test-output-page.component';
import {TestListPageComponent} from './private/test/test-list-page/test-list-page.component';
import {TestDialogComponent} from './private/test/test-dialog/test-dialog.component';
import {FormlyMaterialModule} from '@ngx-formly/material';
import {FormlyModule} from '@ngx-formly/core';
import {TestDialogInfoComponent} from './private/test/test-dialog-info/test-dialog-info.component';
import {
  BoxInterfaceInfoDialogComponent
} from './private/boxes/box-interface-info-dialog/box-interface-info-dialog.component';
import {ObjectTypeComponent} from "./formly/object.type";
import {NullTypeComponent} from "./formly/null.type";
import {TestCardComponent} from './private/test/test-card/test-card.component';
import {AddTestersToTestbedComponent} from './private/testbeds/add-testers-to-testbed/add-testers-to-testbed.component';
import {AddTestersDialogComponent} from './private/testbeds/add-testers-dialog/add-testers-dialog.component';
import {TestOutputInfoDialogComponent} from './private/test/test-output-info-dialog/test-output-info-dialog.component';
import {JsonTreeComponent} from './private/json-tree/json-tree.component';
import {JsonTableComponent} from './private/json-table/json-table.component';
import {
  FormlyTestSchemaInputFileComponent
} from './private/formly-test-schema-input-file/formly-test-schema-input-file.component';
import {FileInputComponent} from './private/file-input/file-input.component';
import {GenericLegendDialogComponent} from './private/generic-legend-dialog/generic-legend-dialog.component';
import {ExecuteListComponent} from './private/execute-list/execute-list.component';
import {AddTestImageComponent} from './private/test-image/add-test-image/add-test-image.component';
import {ListTestImageComponent} from './private/test-image/list-test-image/list-test-image.component';
import {KeycloakAngularModule, KeycloakService} from "keycloak-angular";
import {environment} from "../environments/environment";
import {AUTH_PROVIDER, initAmplifyCognito, initKeycloak} from './services/auth.provider';
import {
  AddDependeciesTestImageComponent
} from './private/add-dependecies-test-image/add-dependecies-test-image.component';
import {TestImageDetailsDialogComponent} from './private/test-image-details-dialog/test-image-details-dialog.component';
import {HasPermissionPipe} from './pipes/has-permission.pipe';
import {ListUsersComponent} from './private/users/list-users/list-users.component';
import {UserFormComponent} from './private/users/user-form/user-form.component';
import {CreateUserDialogComponent} from './private/users/create-user-dialog/create-user-dialog.component';
import {BoxConfigurationPageComponent} from './private/boxes/box-configuration-page/box-configuration-page.component';
import {UserPermissionsFormComponent} from "./private/users/user-permissions-form/user-permissions-form.component";
import {
  UserPermissionsDialogComponent
} from "./private/users/user-permissions-dialog/user-permissions-dialog.component";
import {TokenExpiredInterceptorService} from "./services/token-expired.interceptor.service";


// Add auth-specific modules
// Prepare dynamic imports and providers before @NgModule
// const dynamicImports = [
//
// ];

// if (KeycloakAuthService.isKeycloakEnabled) {
// 	dynamicImports.push(KeycloakAngularModule);
// }
// if (CognitoAuthService.isAwsEnabled) {
// 	dynamicImports.push(AmplifyAuthenticatorModule);
// }
//
// const dynamicProviders: any[] = [
//   DatePipe,
//   SplitCamelCasePipe,
//   BytesPipe,
//   BoxLogsPipe,
//   ReplaceBooleanPipe,
//   MatDatepickerModule,
//   {
//     provide: Loader,
//     useValue: new Loader({
//       apiKey: environment.googleApiKey,
//       libraries: ['places']
//     })
//   },
//   {provide: MAT_DATE_LOCALE, useValue: 'en-UK'},
//   {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true},
//   {provide: HTTP_INTERCEPTORS, useClass: GeneralInterceptorService, multi: true},
//   {
//     provide: MAT_DIALOG_DEFAULT_OPTIONS,
//     useValue: {hasBackdrop: true, disableClose: true, autoFocus: false, panelClass: ['w-50-vw']}
//   },
//   {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {horizontalPosition: 'end'}},
// ];

// if (KeycloakAuthService.isKeycloakEnabled) {
// 	dynamicProviders.push({
// 		provide: APP_INITIALIZER,
// 		useFactory: (keycloak: KeycloakService) => KeycloakAuthService.initializeKeycloak(keycloak),
// 		multi: true,
// 		deps: [KeycloakService]
// 	});
// 	dynamicProviders.push({
// 		provide: AuthService,
// 		useClass: KeycloakAuthService
// 	});
// } else if (CognitoAuthService.isAwsEnabled) {
//
// 	dynamicProviders.push({
// 		provide: AuthService,
// 		useClass: CognitoAuthService
// 	});
// } else {
// 	console.error('No authentication provider configured. Please configure either AWS Cognito or Keycloak in your environment.');
// }
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    PageNotFoundComponent,
    PublicContainerComponent,
    CompanyFormComponent,
    CompanyCardDashboardComponent,
    ContractFormComponent,
    BoxFormComponent,
    BoxInterfaceFormComponent,
    SimFormComponent,
    TestbedFormComponent,
    CreateCompanyDialogComponent,
    ContractDialogStatusTransitionComponent,
    CreateBoxInterfaceDialogComponent,
    CreateBoxDialogComponent,
    CreateSimDialogComponent,
    CreateTestbedDialogComponent,
    ListCompaniesComponent,
    ListContractsComponent,
    ListBoxInterfacesComponent,
    ListSimsComponent,
    ListBoxesComponent,
    ObjectTypeComponent,
    ListTestbedsComponent,
    ListStorageComponent,
    PrivateContainerComponent,
    DashboardComponent,
    GeneralItemDetailDialogComponent,
    SplitCamelCasePipe,
    BytesPipe,
    AlertDialogComponent,
    ConfirmDialogComponent,
    IsAuthenticatedDirective,
    IsInAnyRoleDirective,
    IsInRoleAndStatusForThisEntityDirective,
    IsInAnyStatusDirective,
    ProfileManagementComponent,
    TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT,
    ListTestbedsComponent,
    ContractDialogStatusTransitionComponent,
    ListContractEventsComponent,
    ContractDialogStatusTransitionComponent,
    CreateContractDialogComponent,
    ContractCardDashboardComponent,
    ContractDialogComponent,
    AddResearchersToBoxComponent,
    AddBoxesToContractComponent,
    AddBoxesDialogComponent,
    AddResearchersDialogComponent,
    ReplaceBooleanPipe,
    BoxDialogComponent,
    BoxCardDashboardComponent,
    BoxDialogStatusTransitionComponent,
    ListBoxEventsComponent,
    EnableBoxComponent,
    CreateStorageDialogComponent,
    StorageFormComponent,
    TestbedCardDashboard,
    AddBoxInterfaceToBoxComponent,
    AddBoxInterfaceDialogComponent,
    AddSimToBoxComponent,
    AddSimDialogComponent,
    NotificationsComponent,
    ListTestbedFilesComponent,
    FileUploadDialogComponent,
    StatusLegendDialogComponent,
    BoxCardResearcherDashboardComponent,
    ClientDownloadPageComponent,
    EmailVerificationComponent,
    UserProfileComponent,
    FullCapsPipe,
    GravatarPictureComponent,
    ClientEulaDialogComponent,
    TestOutputPageComponent,
    TestListPageComponent,
    TestDialogComponent,
    TestDialogInfoComponent,
    BoxInterfaceInfoDialogComponent,
    TestCardComponent,
    AddTestersToTestbedComponent,
    AddTestersDialogComponent,
    TestOutputInfoDialogComponent,
    JsonTreeComponent,
    JsonTableComponent,
    FormlyTestSchemaInputFileComponent,
    FileInputComponent,
    GenericLegendDialogComponent,
    ExecuteListComponent,
    AddTestImageComponent,
    ListTestImageComponent,
    AddDependeciesTestImageComponent,
    TestImageDetailsDialogComponent,
    HasPermissionPipe,
    ListUsersComponent,
    UserFormComponent,
    CreateUserDialogComponent,
    BoxConfigurationPageComponent,
    UserPermissionsFormComponent,
    UserPermissionsDialogComponent
  ],
  imports: [
    BrowserModule,
    NgxGpAutocompleteModule,
    FormlyModule.forRoot({
      validationMessages: [
        {name: 'required', message: 'This field is required'},
      ],
      types: [
        {name: 'string', extends: 'input'},
        {
          name: 'number',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'number',
            },
          },
        },
        {
          name: 'integer',
          extends: 'input',
          defaultOptions: {
            templateOptions: {
              type: 'number',
            },
          },
        },
        {name: 'boolean', extends: 'checkbox'},
        {name: 'enum', extends: 'select'},
        {name: 'null', component: NullTypeComponent, wrappers: ['form-field']},
        {name: 'object', component: ObjectTypeComponent},
        {name: 'custom-file-select', component: FormlyTestSchemaInputFileComponent}
      ]
    }),
    FormlyMaterialModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatInputModule,
    MatButtonToggleModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSortModule,
    FlexLayoutModule,
    FlexModule,
    MatInputModule,
    MatSidenavModule,
    MatListModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatTableModule,
    MatTreeModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    A11yModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    FormsModule,
    RxReactiveFormsModule,
    NgxMaskModule.forRoot(),
    MatMenuModule,
    MatProgressBarModule,
    RouterModule,
    MatBadgeModule,
    MatTooltipModule,
    FileSaverModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    MatRadioModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    MatStepperModule,
    AmplifyAuthenticatorModule,
    KeycloakAngularModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [KeycloakService],
      useFactory: (kc: KeycloakService) => async () => {

        const res: any = await (await fetch("/assets/environment.json")).json();
        environment.IDENTITY_PROVIDER = res.IDENTITY_PROVIDER;
        environment.apiUrl = res.apiUrl;
        environment.isChina = res.isChina ?? false;

        if (environment.IDENTITY_PROVIDER === 'cognito') {
          environment.aws = res.aws;
          initAmplifyCognito()();
        } else {
          environment.keycloak = res.keycloak;
          await initKeycloak(kc)();
        }
      }
    },
    AUTH_PROVIDER,
    DatePipe,
    SplitCamelCasePipe,
    BytesPipe,
    ReplaceBooleanPipe,
    MatDatepickerModule,
    {
      provide: Loader,
      useValue: new Loader({
        apiKey: environment.googleApiKey,
        libraries: ['places']
      })
    },
    {provide: MAT_DATE_LOCALE, useValue: 'en-UK'},
    {provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: GeneralInterceptorService, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TokenExpiredInterceptorService, multi: true},
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {hasBackdrop: true, disableClose: true, autoFocus: false, panelClass: ['w-50-vw']}
    },
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {horizontalPosition: 'end'}},
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
